import { render, staticRenderFns } from "./JobBullets.vue?vue&type=template&id=7532dc56&"
import script from "./JobBullets.vue?vue&type=script&lang=js&"
export * from "./JobBullets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports